<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import { authWellyMethods } from "@/state/helpers";
    import Offers from './popup/offers'
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    //import Swal from "sweetalert2"
    export default {
        components: { Layout, PageHeader, Offers },
        props: {},
        data() {
            return {
                idProduct: 1,
                productSelected: null,
                nameProduct:"",
                user: null,
                products:[],
                apiCoreHtml: apiCore,
                isDeactivate: false
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            setProduct(producto) {
                this.productSelected = producto;
            },
            getProducts(){
                let url = `${apiCore}/api/dish/list`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    if (res.valid) {
                        this.products = res.dish
                    } 
                })
            },
            getPromo(product){
                let priceWithDisccount = ""
                if(product.flagPromo){
                    let flagPromo = false
                    let itPromo = 0
                    for(let i=0; i<product.historyPromo.length; i++){
                        if(product.historyPromo[i].active == 1){
                            itPromo = i
                            flagPromo = true
                            break;
                        }
                    }
                    if(flagPromo){
                        if(product.historyPromo[itPromo].discount == "2x1"){
                            // $500 2x$500
                            priceWithDisccount = product.price
                        }else{
                            // $400 de $500
                            let disccountAux = parseInt(product.historyPromo[itPromo].discount)
                            priceWithDisccount = (product.price - ((product.price * disccountAux)/100)).toFixed(2)
                        }
                    }else{
                        priceWithDisccount = product.price
                    }
                }else
                    priceWithDisccount = product.price
                return Number(priceWithDisccount)
            },
            getDisccount(product){
                let Disccount = ""
                if(product.flagPromo){
                    let flagPromo = false
                    let itPromo = 0
                    for(let i=0; i<product.historyPromo.length; i++){
                        if(product.historyPromo[i].active == 1){
                            itPromo = i
                            flagPromo = true
                            break;
                        }
                    }
                    if(flagPromo){
                        if(product.historyPromo[itPromo].discount == "2x1"){
                            // $500 2x$500
                            Disccount = product.historyPromo[itPromo].discount
                        }else{
                            Disccount = product.historyPromo[itPromo].discount+"% OFF"
                        }
                    }else{
                        Disccount = "SIN PROMO"
                    }
                }else
                    Disccount = "SIN PROMO"
                return Disccount
            },
            showModalPromo(product){
                // eslint-disable-next-line
                //console.log(isActivate)
                // eslint-disable-next-line
                //console.log(idProduct)
                //if(isActivate == 1){
                    //this.setIdProduct(idProduct)
                    //this.setNameProduct(nameProduct)
                    this.setProduct(product)
                    this.$bvModal.show('offers'); 
                //}else{
                    //this.setStatusDish(idProduct);
                //}
            },
            formatMoney(price){
                if(price == null)
                    return "$0"
                else
                    return "$"+price
                //return price.toLocaleString('en-IN', {style: 'currency',currency: 'USD', minimumFractionDigits: 2})
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
            // eslint-disable-next-line
            console.log(this.user)
            this.getProducts()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">


            


            <div class="col-md-4" v-for="(product,index) in products" :key="index">
                <div class="card-welly" @click="showModalPromo(product)" style="cursor:pointer;">
                    <div class="row">
                        <div class="col-md-12 container-welly">
                            <div class="row">
                                <div class=" col-sm-12 col-md-5" v-if="product.images.length > 0" style="margin: 10px 0 10px 0;">
                                    <!--<img src="@/assets/images/product.png" width="100%"/>-->
                                    <img crossorigin="anonymous" :src="`${apiCoreHtml}/api/file/${product.images[0].idFile}?token=${user.token}`" width="100%"/>
                                </div>
                                <div class=" col-sm-12 col-md-5" v-if="product.images.length == 0" style="margin: 10px 0 10px 0;">
                                    <img src="@/assets/images/product.png" width="100%"/>
                                </div>

                                <div class=" col-sm-12 col-md-7" style="margin: 10px 0 10px 0;">
                                    <h3 class="title-card">
                                        {{product.name}}
                                    </h3> 
                                    <div class="text-card">
                                        {{product.description}}
                                    </div>
                                    <div class="text-card">
                                        <img src="@/assets/images/special/ACC2_BLACK.svg" v-show="product.glutenFree" style="margin: 0 5px 0 0;" height="20"/>
                                        <img src="@/assets/images/special/VEGGIE_BLACK.svg" v-show="product.veggie" style="margin: 0 5px 0 0;" height="20"/>
                                        <img src="@/assets/images/special/CHEESE_BLACK.svg" v-show="product.vegan" style="margin: 0 5px 0 0;" height="20"/>
                                    </div>
                                    <br/>
                                    <div class="row" v-if="product.flagPromo">
                                        <div class="col-md-6 foot-card">
                                            <span style="font-size: 0.9em;">{{formatMoney(getPromo(product))}}&nbsp;</span> 
                                            <span class="text-medium-line" v-if="getDisccount(product)!='2x1'">{{formatMoney(product.price)}}</span>
                                        </div>
                                        <div class="col-md-6" style="text-align:right" >
                                            <div class="text-offer">{{formatMoney(getDisccount(product))}}</div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="!product.flagPromo">
                                        <div class="col-md-6 foot-card">
                                            <span style="font-size: 0.9em;">{{formatMoney(product.price)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            
        </div>

        <Offers :product="productSelected" :reloadProducts="getProducts"/>
    </Layout>
</template>

<style scoped>

</style>